import React from 'react';

interface ThemeSectionGroupProps {
  /** Empty for a group with no heading */
  title: string;
  /** Under the heading, for what the whole group applies to */
  description?: string;
  className?: string;
  children: React.ReactNode;
}

const ThemeSectionGroup: React.FC<ThemeSectionGroupProps> = ({ title, description, className, children }) => (
  <div className={className ? `theme-section-group ${className}` : 'theme-section-group'}>
    {title && <h4>{title}</h4>}
    {description && <p className="theme-section-group-description">{description}</p>}
    {children}
  </div>
);

export default ThemeSectionGroup;
